import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllattendanceSummaryReport = createAsyncThunk(
    'report/fetchAllemployeeReport',
    async ({fromDate , toDate} : any, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/attendancesummmary?fromDate=${fromDate}&toDate=${toDate}`);

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Attendance Report');
        }
    }
);